export const FETCH_ACCOUNT_REQUEST = 'ACCOUNT/FETCH_ACCOUNT_REQUEST';
export const FETCH_ACCOUNT_SUCCESS = 'ACCOUNT/FETCH_ACCOUNT_SUCCESS';
export const FETCH_ACCOUNT_FAILURE = 'ACCOUNT/FETCH_ACCOUNT_FAILURE';

export const ADD_ACCOUNT_REQUEST = 'ACCOUNT/ADD_ACCOUNT_REQUEST';
export const ADD_ACCOUNT_SUCCESS = 'ACCOUNT/ADD_ACCOUNT_SUCCESS';
export const ADD_ACCOUNT_FAILURE = 'ACCOUNT/ADD_ACCOUNT_FAILURE';

export const UPDATE_ACCOUNT_REQUEST = 'ACCOUNT/UPDATE_ACCOUNT_REQUEST';
export const UPDATE_ACCOUNT_SUCCESS = 'ACCOUNT/UPDATE_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT_FAILURE = 'ACCOUNT/UPDATE_ACCOUNT_FAILURE';

export const REMOVE_ACCOUNT_REQUEST = 'ACCOUNT/REMOVE_ACCOUNT_REQUEST';
export const REMOVE_ACCOUNT_SUCCESS = 'ACCOUNT/REMOVE_ACCOUNT_SUCCESS';
export const REMOVE_ACCOUNT_FAILURE = 'ACCOUNT/REMOVE_ACCOUNT_FAILURE';
